import { postBoxscoreEdits } from 'pages/Settlements/reducers/settlement/actions';


export const mapDispatchToProps = {
  postBoxscoreEdits,
};
